import { formatDate } from "date-fns";
import type { DocumentDTO } from "web_myplann/Infrastructure/Api/Api";
import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";
import { formatFileSize } from "web_myplann/Shared/Utils/formatFileSize";

export const documentSubtitle = (
	document: DocumentDTO,
	showFileSize: boolean,
): string =>
	[
		formatDate(new Date(document.createdAt), DateFormat.Display),
		showFileSize && document.fileSize
			? formatFileSize(document.fileSize)
			: null,
	]
		.filter(Boolean)
		.join(" · ");
